import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

export const slugify = (text) => {
    if (!text) return "";
    return String(text)
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, "")
        .replace(/[\s_-]+/g, "-")
        .replace(/^-+|-+$/g, "");
};

export const titleize = (slug) =>
    (slug || "")
        .split("-")
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
        .join(" ");

export const formatPrice = (price, currency = "GBP") => {
    if (price == null) return "Price on enquiry";
    const symbols = { GBP: "£", USD: "$", AUD: "A$", CAD: "C$", AED: "AED ", EUR: "€", SGD: "S$", NZD: "NZ$" };
    const s = symbols[currency] || currency + " ";
    return `${s}${Number(price).toLocaleString()}`;
};

export const primaryImage = (venue) => {
    const imgs = venue?.images || [];
    if (imgs.length === 0) return "https://images.unsplash.com/photo-1519671482749-fd09be7ccebf?auto=format&fit=crop&w=1200&q=80";
    const p = imgs.find((i) => i.is_primary);
    return resolveImageUrl((p || imgs[0]).url);
};

/**
 * Resolve an image URL. Relative /api/... paths are prefixed with BACKEND_URL
 * so the same stored URL works across preview, prod and custom domains.
 */
export const resolveImageUrl = (url) => {
    if (!url) return url;
    if (url.startsWith("/api/") || url.startsWith("/uploads/")) {
        return `${BACKEND_URL}${url}`;
    }
    return url;
};
